exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button {\r\n  display: inline;\r\n}\r\n\r\n.button span {\r\n  background-color: #669044;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n  margin-top: 10px;\r\n  padding: 12px 23px;\r\n  text-transform: capitalize;\r\n}\r\n", ""]);

// exports
